(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pa-private-sale-gate"] && !Shopify.designMode) return;
  try {
    (() => {
    function initCountdowns() {
      document.querySelectorAll('[data-pa-sale-countdown]').forEach((timer) => {
        if (timer.dataset.initialized) return;
        timer.dataset.initialized = 'true';
        const opens = Number(timer.dataset.opens) * 1000;
        const serverNow = Number(timer.dataset.now) * 1000;
        const started = performance.now();
        if (!Number.isFinite(opens) || !Number.isFinite(serverNow)) return;
        let interval;
        function tick() {
          if (!timer.isConnected) { clearInterval(interval); return; }
          const left = Math.max(0, Math.ceil((opens - serverNow - (performance.now() - started)) / 1000));
          const units = {days: Math.floor(left/86400), hours: Math.floor(left%86400/3600), minutes: Math.floor(left%3600/60), seconds: left%60};
          Object.entries(units).forEach(([unit, value]) => { timer.querySelector('[data-unit="' + unit + '"]').textContent = String(value).padStart(2, '0'); });
          if (left === 0) {
            clearInterval(interval);
            const destination = new URL(window.location.href);
            destination.searchParams.set('_pa_open', String(Date.now()));
            window.location.replace(destination.toString());
          }
        }
        interval = setInterval(tick, 1000);
        tick();
      });
    }
    initCountdowns();
    document.addEventListener('shopify:section:load', initCountdowns);
  })();
  } catch(e) { console.error(e); }
})();

})();
